import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'peps-separator',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './separator.component.html',
})
export class SeparatorComponent {

}
